import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lmnp-setting',
    templateUrl: './lmnp-setting.component.html',
    styleUrls: ['./lmnp-setting.component.scss'],
    standalone: false
})
export class LmnpSettingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
